import React from 'react';
import { ROOM_BOOKING_OPTIONS } from '../utils/roomBookingOptions';

/**
 * Button-based room option picker (avoids native radio groups conflicting across
 * hidden desktop/mobile layouts that share the same document).
 */
const RoomBookingOptionPicker = ({
  roomId,
  roomOptions,
  selectedOption,
  onChange,
  layout = 'inline',
}) => {
  const current = selectedOption || ROOM_BOOKING_OPTIONS.ROOM_ONLY;

  const choices = [
    { value: ROOM_BOOKING_OPTIONS.ROOM_ONLY, label: 'Room Only' },
  ];
  if (roomOptions?.withBreakfast) {
    choices.push({ value: ROOM_BOOKING_OPTIONS.WITH_BREAKFAST, label: 'Breakfast' });
  }
  if (roomOptions?.withSpa) {
    choices.push({ value: ROOM_BOOKING_OPTIONS.WITH_SPA, label: layout === 'stacked' ? 'Spa Package' : 'Spa' });
  }

  if (layout === 'stacked') {
    return (
      <div
        role="radiogroup"
        aria-label="Room booking option"
        className="flex flex-col border border-[#f0f0f0] rounded-[14px] mb-4 overflow-hidden"
      >
        {choices.map((choice, index) => (
          <React.Fragment key={choice.value}>
            {index > 0 && (
              <div className="flex items-center justify-center">
                <svg width="100%" height="1px">
                  <line x1="0" y1="1" x2="100%" y2="1" stroke="#f0f0f0" strokeWidth="2" strokeDasharray="10 4" />
                </svg>
              </div>
            )}
            <button
              type="button"
              role="radio"
              aria-checked={current === choice.value}
              onClick={() => onChange(roomId, choice.value)}
              className={`flex w-full items-center gap-[6px] p-[12px] text-left transition-colors ${
                current === choice.value ? 'bg-[#FFF5F4]' : 'bg-white hover:bg-[#FAFAFA]'
              }`}
            >
              <span
                className={`flex h-[20px] w-[20px] shrink-0 items-center justify-center rounded-full border-2 ${
                  current === choice.value ? 'border-[#FF5E4C]' : 'border-[#d9d9d9] bg-[#f0f0f0]'
                }`}
              >
                {current === choice.value && (
                  <span className="h-[10px] w-[10px] rounded-full bg-[#FF5E4C]" />
                )}
              </span>
              <span className="text-[14px] font-medium text-black">{choice.label}</span>
            </button>
          </React.Fragment>
        ))}
      </div>
    );
  }

  return (
    <div
      role="radiogroup"
      aria-label="Room booking option"
      className="flex items-center gap-[16px] py-[12px]"
    >
      {choices.map((choice) => (
        <button
          key={choice.value}
          type="button"
          role="radio"
          aria-checked={current === choice.value}
          onClick={() => onChange(roomId, choice.value)}
          className="flex items-center gap-[6px] cursor-pointer"
        >
          <span
            className={`flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-full border-2 ${
              current === choice.value ? 'border-[#FF5E4C]' : 'border-[#d9d9d9]'
            }`}
          >
            {current === choice.value && (
              <span className="h-[9px] w-[9px] rounded-full bg-[#FF5E4C]" />
            )}
          </span>
          <span className="text-[14px] font-medium text-black leading-none">{choice.label}</span>
        </button>
      ))}
    </div>
  );
};

export default RoomBookingOptionPicker;
